import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { LArrowDirectionEnum } from '@winelidays/wld-tsx-2/types';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getLimitedArray = ({ array, limit }) => {
    const newArray = [...array];
    newArray.length = limit;
    return newArray;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useListLimit = (array, t0) => {
    const $ = _c(15);
    const limit = t0 === undefined ? 3 : t0;
    const translate = useTranslate();
    const [limited, setLimited] = useState(true);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = () => {
            setLimited(_temp);
        };
        $[0] = t1;
    }
    else {
        t1 = $[0];
    }
    const toggleLimited = t1;
    const usesLimit = limit < array.length;
    let t2;
    if ($[1] !== array || $[2] !== limit || $[3] !== limited || $[4] !== usesLimit) {
        t2 = usesLimit && limited ? getLimitedArray({
            array,
            limit
        }) : array;
        $[1] = array;
        $[2] = limit;
        $[3] = limited;
        $[4] = usesLimit;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const limitedArray = t2;
    let t3;
    if ($[6] !== limited || $[7] !== translate) {
        t3 = capitalize(limited ? translate("messages.see_more") : translate("messages.see_less"));
        $[6] = limited;
        $[7] = translate;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    const seeMoreLabel = t3;
    const arrowDirection = limited ? LArrowDirectionEnum.Bottom : LArrowDirectionEnum.Top;
    let t4;
    if ($[9] !== arrowDirection || $[10] !== limited || $[11] !== limitedArray || $[12] !== seeMoreLabel || $[13] !== usesLimit) {
        t4 = {
            usesLimit,
            limited,
            toggleLimited,
            limitedArray,
            seeMoreLabel,
            arrowDirection
        };
        $[9] = arrowDirection;
        $[10] = limited;
        $[11] = limitedArray;
        $[12] = seeMoreLabel;
        $[13] = usesLimit;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    return t4;
};
export default useListLimit;
function _temp(c) {
    return !c;
}
